<template>
  <footer class="shell-footer">
    <v-sheet
      class="overflow-hidden position-relative"
      color="primary"
      max-width="100vw"
    >
      <v-container class="py-0">
        <div class="grid-list">
          <div
            class="
              d-flex
              align-center
              justify-center justify-md-start
              primary
              lighten-2
              py-6
              pr-10 pr-md-16
              mx-n3 mx-md-0
              grid-list-item grid-list-item-logotipo
            "
          >
            <router-link to="/">
              <img
                v-if="informations.img"
                class="d-block mx-auto mx-md-0 filter-white"
                :src="files + informations.img"
                height="80px"
              />
            </router-link>
          </div>

          <div class="d-flex flex-column align-start py-6 grid-list-item">
            <div
              class="
                white--text
                text-subtitle-1
                font-weight-bold
                text-uppercase
                px-4
                mb-2
              "
            >
              Contato
            </div>

            <div
              v-for="(
                { text, link, target, name, icon, size }, keyContact
              ) in contacts"
              :key="keyContact"
            >
              <v-btn
                class="
                  grey--text
                  text--lighten-4 text-body-1 text-none
                  font-weight-regular
                  btn-contact
                "
                height="auto"
                min-height="36px"
                :href="link"
                :target="target"
                :title="name"
                depressed
                color="transparent"
              >
                <v-icon v-if="icon" :size="size" class="mr-2" color="white">
                  {{ icon }}
                </v-icon>

                <span v-html="text"></span>
              </v-btn>
            </div>

            <div class="d-flex flex-column align-start">
              <v-btn
                class="
                  grey--text
                  text--lighten-4 text-body-1 text-none
                  font-weight-regular
                  btn-contact
                "
                height="auto"
                min-height="36px"
                to="/politica-de-privacidade"
                color="transparent"
                depressed
              >
                <v-icon :size="18" class="mr-2" color="white">
                  fa-shield-alt
                </v-icon>

                Política de Privacidade
              </v-btn>
            </div>
          </div>

          <div
            class="
              d-flex
              align-center
              justify-center justify-sm-end
              py-6
              grid-list-item
            "
          >
            <div class="d-flex justify-center justify-sm-end align-center">
              <div
                v-for="({ text, link, icon, size }, keySocial) in social"
                :key="keySocial"
                class="d-inline-flex"
                :class="{ 'ml-2': keySocial > 0 }"
              >
                <v-btn
                  :href="link"
                  target="_blank"
                  min-width="auto"
                  color="grey lighten-4"
                  small
                  :title="text"
                  depressed
                  rounded
                  fab
                >
                  <v-icon color="primary" :size="size">{{ icon }}</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </v-container>
    </v-sheet>

    <v-sheet color="primary darken-2">
      <v-container
        class="
          pt-0
          pb-5
          d-flex
          flex-column flex-sm-row
          justify-space-between
          align-center
          text-center
        "
      >
        <div
          class="
            grey--text
            text--lighten-4 text-body-1
            font-weight-regular
            mt-5
          "
        >
          <b class="font-weight-bold"> {{ informations.name }}</b>
          © {{ year }}

          <span class="d-block d-sm-inline-block">
            Todos os direitos reservados.
          </span>
        </div>
        <a
          class="d-flex mt-5"
          href="https://www.mrxweb.com.br/"
          target="_blank"
        >
          <img
            class="shell-footer-logo"
            src="../../assets/img/mrxweb.svg"
            alt="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
            title="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
            height="20px"
          />
        </a>
      </v-container>
    </v-sheet>
  </footer>
</template>

<script>
import { getContact } from "../../utils/getContact";
import { getSocial } from "../../utils/getSocial";

export default {
  data: () => ({
    year: new Date().getFullYear(),
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    contacts() {
      return getContact(this.informations);
    },
    social() {
      return getSocial(this.informations);
    },
  },
};
</script>

<style lang="scss" scoped>
.shell-footer {
  .grid-list {
    display: grid;
    gap: 24px 48px;
    grid-template-columns: auto 1fr auto;
    justify-content: space-between;

    @media screen and (min-width: 600.001px) and (max-width: 960px) {
      gap: 24px;
      grid-template-columns: auto auto;

      &-item:first-child {
        grid-column: 1 / -1;
      }
    }

    @media screen and (max-width: 600px) {
      grid-template-columns: 100%;
    }

    .grid-list-item-logotipo {
      position: relative;

      &:before {
        background-color: var(--v-primary-lighten2);
        bottom: 0;
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        width: 50vw;
      }
    }

    .btn-contact::v-deep {
      .v-btn__content {
        max-width: 100%;
        white-space: normal;
        word-break: break-word;
      }
    }
  }
}
</style>
